<template>
    <div class="box">
        <div class="top">职场打卡</div>
        <div class="content">
            <div>
                <div class="slider contain">进入职场打卡</div>
                <van-cell-group>
                    <van-field
                            label="姓名"
                            v-model="form.name"
                            label-class="left"
                            :disabled="true"
                    />
                    <van-field
                            readonly
                            clickable
                            label="所在职场"
                            :value="workplacename"
                            placeholder="请先选择职场"
                            label-class="left"
                            @click="showPicker = true"
                    />

                    <van-cell>
                        <van-button icon="arrow-down" :disabled="form.latitude=='' || form.qrcodeInfo==''" round type="primary" size="small" @click="enterorleave('01')">入场</van-button>
                        <van-button icon="arrow-up" :disabled="form.longitude=='' || form.qrcodeInfo==''" round type="danger" size="small" style="margin-left: 20px" @click="enterorleave('02')">离场</van-button>
                    </van-cell>



                </van-cell-group>
                <!-- 健康状况 -->
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="workplaces"
                            @cancel="showPicker = false"
                            @confirm="onConfirm"
                    />
                </van-popup>

                <van-overlay :show="show" >
                    <div class="wrapper">
                        <van-loading class="block" color="#1989fa" size="24px">{{loadingtext}}</van-loading>
                    </div>
                </van-overlay>
            </div>
        </div>
    </div>
</template>

<script>
    import wxConfig from "../api/wxconfig";
    import auth from "../api/userauth";
    import {getWechatConfig, getWorkPlaces, punchInfo} from "../api/api";

    export default {
        data() {
            return {
                workplacename: "",
                workplaces: [],
                workplacesJson: [],
                form: {
                    userId: "",
                    mobile: "",
                    name: "",
                    latitude: "",
                    longitude: "",
                    qrcodeInfo: "",
                    type: ''
                },
                showPicker: false,
                show: false,
                loadingtext: '',
            }
        },
        methods: {
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            onConfirm(value) {
                this.workplacename=value
                this.form.qrcodeInfo = this.workplacesJson.filter(
                    v => v.label == value
                )[0].value;
                this.showPicker = false;
                this.openFullScreen()
                this.getLocaltion()
            },
            getWorkPlaces() {
                getWorkPlaces().then(res => {
                    let temdata = res.data
                    if (temdata.success) {
                        let options = temdata.result;
                        this.workplaces = [];
                        this.workplacesJson = []
                        this.workplaces = options.map(v => {
                            return v.name;
                        });
                        options.forEach(val => {
                            this.workplacesJson.push({"value": val.qrInfo, "label": val.name})
                        })
                        console.log(this.workplaces)
                    }
                })
            },
            openFullScreen() {
                this.show=true
                this.loadingtext='正在获取地理位置'
            },
            enterorleave(type) {
                this.form.type = type
                punchInfo(this.form).then(res => {
                    let temdata = res.data
                    if (temdata.success) {
                        this.$dialog.alert({
                            message: '打卡成功!'
                        });

                    } else {
                        this.$dialog.alert({
                            message: '打卡失败!'
                        });
                    }
                })
            },
            getLocaltion() {
                let that = this
                wx.getLocation({
                    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function (res) {
                        // alert(JSON.stringify(res))
                        that.form.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                        that.form.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                        var speed = res.speed; // 速度，以米/每秒计
                        var accuracy = res.accuracy; // 位置精度
                        that.show=false
                    }
                });
            }
        },
        created() {
            document.title = '职场管理'
            if (!this._isMobile()) {
                this.loadingtext='请使用手机端打开...'
                this.show=true
                return;
            }
            let userstr = sessionStorage.getItem("user");
            let user;
            let that = this;
            that.getWorkPlaces()
            if (userstr != null && userstr != '{}') {
                // alert('has');
                user = JSON.parse(userstr);
                this.form.userId = user.userId;
                this.form.name = user.name;
                this.form.mobile = user.mobile;
            } else {
                auth.getCode().then(res => {
                    let data = JSON.stringify(res.data);
                    //alert('data:'+data)
                    if (data != '{}') {
                        sessionStorage.setItem('user', data);
                        let user = JSON.parse(sessionStorage.getItem("user"));
                        this.form.userId = user.userId;
                        this.form.name = user.name;
                        this.form.mobile = user.mobile;
                        let url = window.location.href
                        getWechatConfig(url).then((res) => {
                            let data = JSON.parse(res.data)
                            wxConfig.wxConfig(data)
                        })
                    } else {
                        this.$dialog.alert({
                            message: '请在企业微信中打开该页面!'
                        });
                    }
                })
            }


        }
        ,
        mounted() {

        }
        ,
        destroyed() {

        }
    }


</script>

<style>

    #app{
        margin-top: 10px !important;

    }

    .top {
        height: 2.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        font-weight: bold;
        background: #fff;
    }

    .content {
        background: #fff;
        /* margin-top: 2.8rem; */
        color: #000;
    }


    .slider {
        width: 100%;
        height: 0.5rem;
        background: rgb(234, 233, 231);
    }

    .contain {
        height: 3rem;
        display: flex;
        align-items: center;
        padding-left: 0.6rem;
        font-size: 13px;
        box-sizing: border-box;
        color: #6d6c6b;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .block {
        height: 120px;
    }

</style>
